import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import './contact.css'
import { MdEmail } from 'react-icons/md'
import {FaLinkedin, FaInstagram} from 'react-icons/fa'

const Contact = () => {
  const form = useRef();

    const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_pcvfk7e', 'template_uxlaesm', form.current, 'fApb-evxR92yWHhD2')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
  };
  return (
    <section id='contact' data-aos="zoom-out-up">
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact_container">
        <div className="contact_options">
          <article className='contact_option'>
            <MdEmail className='contact_option-icon'/>
            <h4>Email</h4>
            <h5>deshdeepakkushwaha04@gmail.com</h5>
            <a href='mailto:deshdeepakkushwaha04@gmail.com' target="_blank" rel="noreferrer">Send a message</a>
          </article>
            <article className='contact_option'>
            <FaLinkedin className='contact_option-icon'/>
            <h4>LinkedIn</h4>
            <h5>Desh Deepak Kushwaha</h5>
            <a href='https://www.linkedin.com/in/desh-deepak-kushwaha-b65929254/' target="_blank" rel="noreferrer">Send a message</a>
          </article>
          <article className='contact_option'>
            <FaInstagram className='contact_option-icon'/>
            <h4>Instagram</h4>
            <h5>deepu_4477</h5>
            <a href='https://www.instagram.com/deepu_4477/?igshid=NTA5ZTk1NTc%3Ds' target="_blank" rel="noreferrer">Send a message</a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail} >
          <input type="text" name='name' placeholder='Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <input type="text" name='contact' placeholder='Your Contact No.' required />
          <textarea name='message' rows="7" placeholder="Type your message" required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact